{
    "DAYS": "days",
    "HOURS": "hours",
    "MINUTES": "min",
    "SECONDS": "sec",
    "STARTING_SOON": "Starting soon...",
    "EVENT_NOT_STARTED": "This event has not started...",
    "DEFAULT_ERROR": "Playback Error",
    "DEFAULT_ERROR_DESCRIPTION": "Unable to play the video. Please try again later.",
    "API_ERROR": "Failed to Retrieve Video Info",
    "API_ERROR_DESCRIPTION": "Error fetching video details. Check your videoId and internet connection and try again.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Authorisation",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "You don't have permission to play this video.",
    "ERROR_CODE_GEO_BLOCKED": "Geoblocking Restriction",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Sorry, this video is not available in your region due to geoblocking restrictions.",
    "ERROR_CODE_NOT_ENTITLED": "Not entitled",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Sorry, you are not entitled to play this video.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOCKED",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "This video is not available due to the use of a VPN.",
    "ERROR_CODE_IP_CHANGED": "Network Changed",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "You have switched to different network unexpectedly. Please try again.",
    "ERROR_CODE_VPN_DETECTED": "VPN Detected",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "We've detected a VPN. Please turn this off and try again.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Anonymous Proxy Detected",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "We've detected an anonymous proxy or server. Please turn this off and try again.",
    "CONCURRENCY_KICKED": "Device Limit Reached",
    "CONCURRENCY_KICKED_DESCRIPTION": "You have exceeded the limit of devices allowed to watch this video at the same time.",
    "CONCURRENCY_CONNECTION_FAILED": "Connection Error",
    "CONCURRENCY_CONNECTION_FAILED_DESCRIPTION": "Unable to establish a connection. Please try again."
}
